import React from 'react';
import './Cover.css';

const Cover: React.FC = () => {
  return (
    <div className="cover">
      <div className="cover__image-container">
        <img src="/cover.jpeg" alt="Cover" className="cover__image" />
      </div>
      <div className="cover__content">
        <div className='cover__logo__container'>
          <img src="/logo.png" alt="Logo" className="cover__logo" />
        </div>
        <div className='album'>
          <a  type="submit" className="sharing_photos" href="https://www.casamentos.pt/web/rita-jorge-25/ritajorge-8">Partilha as tuas fotos!</a>
          <p className="album-subheader">Código do álbum <span className="album-highlight">PT9c378c2d</span></p>
        </div>
        <img src="/info.jpeg" alt="Info" className="cover__info" />
      </div>
    </div>
  );
};

export default Cover;
